<template>
<nav class="navbar fixed-top">
    <div class="d-flex align-items-center navbar-left">

        <a href="#" class="menu-button  d-md-block" @click.prevent.stop="changeSideMenuStatus({step :menuClickCount+1,classNames:menuType,selectedMenuHasSubItems})">
            <menu-icon />
        </a>

        <!--      <a href="#" class="menu-button-mobile d-xs-block d-sm-block d-md-none"-->
        <!--         @click.prevent.stop="changeSideMenuForMobile(menuType)">-->
        <!--        <mobile-menu-ic on/>-->
        <!--      </a>-->

        <b-form v-if="info != null " inline class=" d-md-block">
            <div class="mt-1 mobile-hide">
                <b-form-group>
                    <b-form-input placeholder="전화번호 뒷 4자리" v-model="$v.searchKeyword.$model" :state="!$v.searchKeyword.$error" :maxlength="4" />
                    <b-form-invalid-feedback :v-if="!$v.searchKeyword.numeric">숫자만 입력 가능합니다.
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
        </b-form>
        <div v-if="info != null " class="mobile-hide position-relative mt-1 d-md-block">
            <b-button class="btn-sm ml-2" variant="outline-primary" @click="showModal">쿠폰 조회</b-button>
            <b-button class="btn-sm ml-2" variant="outline-primary" @click="showBookingModal">예약 조회</b-button>
        </div>
    </div>

    <!-- 쿠폰조회 모달 -->
    <template>
        <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
            <b-modal id="couponmodal" ref="couponmodal" size="xl" title="쿠폰 조회" :hide-backdrop="false" :no-close-on-backdrop="true">
                <coupon-modal :data="searchKeyword">
                </coupon-modal>
                <template slot="modal-footer">
                    <b-button variant="outline-primary" @click="hideModal">닫기</b-button>
                </template>
            </b-modal>
        </b-row>
    </template>

    <!-- 예약조회 모달 -->
    <template>
      <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
        <b-modal id="bookingmodal" ref="bookingmodal" size="xl" title="예약 조회" :hide-backdrop="false"
                 :no-close-on-backdrop="true">
          <booking-modal :data="searchKeyword" :topBookingBtn="true" calendarType="topnav" calendarTime="topnav">
          </booking-modal>
          <template slot="modal-footer">
            <b-button variant="outline-primary" @click="hideBookingModal">닫기</b-button>
          </template>
        </b-modal>
      </b-row>
    </template>

    <!-- 수기예약 모달 -->
    <template>
        <b-modal id="callReservation" ref="callReservation" title="예약하기" :hide-backdrop="false" :no-close-on-backdrop="true" @ok="modalHideClick"  @hidden="resetModal" @show="openModal">
            <CallReservation :messsingText="messsingText" :cidmeasg='cidmeasg'></CallReservation>
            <template slot="modal-footer">
                <b-button variant="outline-primary" @click="callReservationHideModal">닫기</b-button>
            </template>
        </b-modal>
    </template>

    <router-link class="navbar-logo" tag="a" :to="toHome()">
        <!-- PC LOGO -->
        <!--        <span class="logo d-none d-xs-block"></span>-->
        <!-- Mobile LOGO -->
        <!--        <span class="logo-mobile d-block d-xs-none"></span>-->
        <span class="main-logo"><span class="reds">HI</span>TABLE</span>
    </router-link>

    <div class="navbar-right">

        <!--            <div class="d-none d-md-inline-block align-middle mr-3">-->
        <!--              <switches id="tool-mode-switch" v-model="isDarkActive" theme="custom" class="vue-switcher-small"-->
        <!--                        color="primary"/>-->
        <!--              <b-tooltip target="tool-mode-switch" placement="left" title="Dark Mode"></b-tooltip>-->
        <!--            </div>-->
        <!--            <div class="header-icons d-inline-block align-middle">-->
        <!--              <div class="position-relative d-none d-sm-inline-block">-->
        <!--                <div class="btn-group">-->
        <!--                  <b-button variant="empty" class="header-icon btn-sm" @click="toggleFullScreen">-->
        <!--                    <i-->
        <!--                      :class="{'d-inline-block':true,'simple-icon-size-actual':fullScreen,'simple-icon-size-fullscreen':!fullScreen }"/>-->
        <!--                  </b-button>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->

        <div class="user d-inline-block">
            <b-button variant="primary" class="mr-3" @click="callReservationShowModal('btn')">예약접수</b-button>
            <b-button href="https://drive.google.com/file/d/15wAWekghrTzuMCOBw1w9vs6Op_UxSuW7/view?usp=sharing" target="_blank" variant="outline-danger" class="mr-3 mobile-hide">
                <b-icon-download></b-icon-download><span class="mr-1">이용가이드</span>
            </b-button>
            <b-dropdown class="dropdown-menu-right" variant="primary" menu-class="mt-3" no-caret>
                <template slot="button-content">
                    <span v-if="infoFlag" class="mr-1">{{ info.username }}</span>
                </template>
                <!--          <b-dropdown-item @click="modifyMember">정보수정</b-dropdown-item>-->
                <b-dropdown-item @click="modifyMember">비밀번호 수정</b-dropdown-item>
                <b-dropdown-item @click="logout">{{ $t('user.logout') }}</b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</nav>
</template>

<script>
import Switches from "vue-switches";
import notifications from "../data/notifications";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import CouponModal from "../components/Pages/CouponModal";
import BookingModal from "../components/Pages/BookingModal";

import {
    validationMixin
} from "vuelidate";

const {
    required,
    numeric
} = require("vuelidate/lib/validators");

import {
    mapGetters,
    mapMutations,
    mapActions
} from "vuex";
import {
    MenuIcon,
    MobileMenuIcon
} from "../components/Svg";
import {
    menuHiddenBreakpoint,
    localeOptions,
    defaultColor
} from "../constants/config";
import CallReservation from "@/views/booking/CallReservation";

import {
    eventBus,
} from "../utils";

export default {
    components: {
        CallReservation,
        "v-select": vSelect,
        "menu-icon": MenuIcon,
        "mobile-menu-icon": MobileMenuIcon,
        switches: Switches,
        'coupon-modal': CouponModal,
        'booking-modal': BookingModal
    },
    mixins: [validationMixin],
    validations: {
        searchKeyword: {
            numeric
        }
    },
    data() {
        return {
            infoFlag: false,
            username: '',
            selectedParentMenu: "",
            searchKind: "PhoneNumber4",
            searchKeyword: "",
            isMobileSearch: false,
            isSearchOver: false,
            fullScreen: false,
            menuHiddenBreakpoint,
            localeOptions,
            notifications,
            isDarkActive: false,
            topSearchShow: true,
            messaging: false,
            messsingText: '',
            cidmeasg: '',
            onThePhone: true,
            onThePhoneModal: true,
            moduleOpenWhether: false,
            mountedState: true,
        };
    },
    mounted() {
        this.getUserInfo();
        eventBus.$on('bus-event-messaging', this.messagingFunc);
    },
    beforeDestroy() {
        eventBus.$off('bus-event-messaging', this.messagingFunc)
    },
    computed: {

        ...mapGetters({
            info: "info",
            currentUser: "currentUser",
            menuType: "getMenuType",
            menuClickCount: "getMenuClickCount",
            selectedMenuHasSubItems: "getSelectedMenuHasSubItems",
            siteName: 'siteName',
            brandInfo: 'brandInfo'
        }),
        // searchPlaceHoler: {
        //   get: function() {
        //     return this.searchKind === "PhoneNumber4" ? "전화번호 뒷 4자리" : "쿠폰번호 12자리"
        //   }
        // }

    },

    methods: {
        messagingFunc(val, type) {
            let eventStop = true;
            let foreground = true;
            let condition = true;

            // 통화종료 push 이벤트 2번 제어
            if (typeof (val.data) !== "undefined") {
                if (val.data.callStatus === "finish"){
                    eventStop = false;
                    foreground = false;
                }
            }else{
                condition = false; // 통화종료 상태값
            }

            // 백그라운드 js mounted 에서 2번 발생 현상 제어
            if (val.messageType !== undefined){
                if (val.messageType === "push-received"){
                    eventStop = false;
                    foreground = false;
                }
            } else if (!condition){
                foreground = true;
            }

            if (this.moduleOpenWhether && foreground) {
                let phoneNumber = '';
                if (typeof (val.data) !== "undefined") {
                    phoneNumber = val.data.phoneNumber;
                }else{
                    phoneNumber = val.phoneNumber;
                }
                if (confirm(`[${phoneNumber}] 에서 전화가 왔습니다. 조회하시겠습니까?\n(조회하시면 기존에 작성하던 정보는 저장되지 않습니다.)`)) {
                    eventStop = true;
                } else {
                    eventStop = false;
                }
            }

            if (!eventStop) {
                return;
            }
            if (JSON.parse(sessionStorage.getItem("BRAND_USER_INFO")).userRole !== 'STORE_MANAGER') {
                alert('매장 관리자 에서 사용 가능한 기능 입니다.');
                return
            }
            let text = '';
            if (typeof (val.data) !== "undefined") {
                text = val.data.phoneNumber;
                eventBus.$emit('bus-event-phoneNumber', val.data.phoneNumber, false);
                console.log(val.data.phoneNumber)
            } else {
                text = val.phoneNumber;
                eventBus.$emit('bus-event-phoneNumber', val.phoneNumber, false);
                console.log(val.phoneNumber)
            }
            if (this.$refs['callReservation'] !== undefined) {
                this.callReservationHideModal();
                this.callReservationShowModal();
            }

            if (text !== undefined) {
                this.messsingText = text;
            }


        },
        modalHideClick() {
            document.body.classList.add('nopos')
        },
        callReservationShowModal(mode) {
            console.log('show')
            if (mode == 'btn') {
                this.messsingText = '';
            }
            this.$refs['callReservation'].show();
            document.body.classList.add('nopos')
        },
        resetModal(){
            this.moduleOpenWhether = false;
        },
        openModal(){
            this.moduleOpenWhether = true;
        },
        callReservationHideModal() {
            this.$refs['callReservation'].hide();
            document.body.classList.remove('nopos')
            console.log('hide')
        },

        hideModal() {
            this.$refs['couponmodal'].hide();
        },

        hideBookingModal() {
            this.$refs['bookingmodal'].hide();

        },

        showModal() {
            this.$v.$touch();
            if (!this.$v.$anyError) {
                this.$refs['couponmodal'].show();
            }
        },

        showBookingModal() {
            this.$v.$touch();
            if (!this.$v.$anyError) {
                this.$refs['bookingmodal'].show();
            }

        },

        ...mapMutations(["changeSideMenuStatus", "changeSideMenuForMobile"]),
        ...mapActions(["setLang", "signOut", "userInfo"]),

        getUserInfo() {
            this.userInfo()
        },

        search() {
            this.$v.$touch();
            if (!this.$v.$anyError) {
                this.$router.push(`/${this.siteName}/coupon/coupon-search/${this.searchKind}/${this.searchKeyword}`);
                this.searchKeyword = "";
            }
        },

        handleDocumentforMobileSearch() {
            if (!this.isSearchOver) {
                this.isMobileSearch = false;
                this.searchKeyword = "";
            }
        },

        modifyMember() {
            this.$router.push(`/${this.siteName}/member/user-modify`)
        },

        logout() {
            this.signOut().then(() => {

                // navigator.serviceWorker.getRegistrations().then(function (registrations) {
                //     for (let registration of registrations) {
                //         registration.unregister();
                //     }
                // });
                // if (self.name != 'reload') {
                //     self.name = 'reload';
                //     self.location.reload(true);
                // } else self.name = '';
                this.$router.push(`/${this.siteName}/user/login`);
            });
        },

        toggleFullScreen() {
            const isInFullScreen = this.isInFullScreen();

            var docElm = document.documentElement;
            if (!isInFullScreen) {
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen();
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen();
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen();
                } else if (docElm.msRequestFullscreen) {
                    docElm.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
            this.fullScreen = !isInFullScreen;
        },
        getThemeColor() {
            return localStorage.getItem("themeColor") ?
                localStorage.getItem("themeColor") :
                defaultColor;
        },
        isInFullScreen() {
            return (
                (document.fullscreenElement && document.fullscreenElement !== null) ||
                (document.webkitFullscreenElement &&
                    document.webkitFullscreenElement !== null) ||
                (document.mozFullScreenElement &&
                    document.mozFullScreenElement !== null) ||
                (document.msFullscreenElement && document.msFullscreenElement !== null)
            );
        },
        toHome() {
            return `/${this.siteName}`;
        }
    },

    beforeDestroy() {

        document.removeEventListener("click", this.handleDocumentforMobileSearch);
    },

    created() {
        const color = this.getThemeColor();
        this.isDarkActive = color.indexOf("dark") > -1;
    },

    watch: {
        messaging(val) {
            console.log(val);
            if (this.messaging === true) {
                this.callReservationShowModal();
                this.messaging = false;
            }
        },
        info(val) {
            if (val !== null) this.infoFlag = true
        },

        "$i18n.locale"(to, from) {
            if (from !== to) {
                this.$router.go(this.$route.path);
            }
        },

        $route() {
            const path = this.$route.path
            // this.topSearchShow = path.includes('coupon/coupon-search') || path.includes('/booking/booking-visit') ? false : true
        },

        isDarkActive(val) {
            let color = this.getThemeColor();
            let isChange = false;
            if (val && color.indexOf("light") > -1) {
                isChange = true;
                color = color.replace("light", "dark");
            } else if (!val && color.indexOf("dark") > -1) {
                isChange = true;
                color = color.replace("dark", "light");
            }
            if (isChange) {
                localStorage.setItem("themeColor", color);
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            }
        },

        isMobileSearch(val) {
            if (val) {
                document.addEventListener("click", this.handleDocumentforMobileSearch);
            } else {
                document.removeEventListener(
                    "click",
                    this.handleDocumentforMobileSearch
                );
            }
        }
    } //watch
};
</script>

<style>
#callReservation {
    max-width: 100%;
}

div#callReservation .modal-dialog.modal-md {
    max-width: 87%;
}

img.align-self-center.login2Logo {
    width: 20px;
    margin-right: 5px;
    margin-bottom: 4px;
}

.reds {
    color: #b71f25;
}
</style>
